import store from "@/store"

export default {
  inserted(el, binding) {
    //获取binding对象中绑定的value
    const { value } = binding
    const ctrlperm = store.getters && store.getters.perm
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value
      //console.log("+++++++++++", ctrlperm)
      const hasPermission = ctrlperm.some(item => {
        return permissionRoles.includes(item.path)
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need roles, like v-permission ="['admin','editor']"`)
    }
  }
}
